var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/landing/logo_black.png",
            searchImgSrc: "../../../../static/img/landing/search_black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("section", { staticClass: "top-News pt-0 pb-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "st-Grid_Inner st-Grid_Inner_appear p-0 pl-md-5"
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "sw-Section_Header",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("span", { staticClass: "sw-Section_Header-en" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("SHOW")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sw-Section_Header-ja" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("工場展示")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "st-News_Slide swiper-container-news swiper-container-initialized swiper-container-horizontal appear",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "swiper-wrapper" },
                          _vm._l(_vm.newsData, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "swiper-slide swiper-slide-news"
                              },
                              [
                                _c("a", { attrs: { href: item.link } }, [
                                  _c(
                                    "div",
                                    { staticClass: "st-News_Slide-image" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "st-News_Slide-image-inner"
                                        },
                                        [
                                          _c("div", {
                                            style: {
                                              "background-image": item.imgSrc
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "sw-Eyebrow" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "sw-Eyebrow_Lavel",
                                        attrs: { "data-lavel": "product" }
                                      },
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit"
                                            }
                                          },
                                          [
                                            _c(
                                              "font",
                                              {
                                                staticStyle: {
                                                  "vertical-align": "inherit"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.lavel))]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "sw-Eyebrow_Category" },
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit"
                                            }
                                          },
                                          [
                                            _c("font", {
                                              staticStyle: {
                                                "vertical-align": "inherit"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "sw-Eyebrow_Date" },
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit"
                                            }
                                          },
                                          [
                                            _c(
                                              "font",
                                              {
                                                staticStyle: {
                                                  "vertical-align": "inherit"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.date))]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "st-News_Slide-title" },
                                    [
                                      _c(
                                        "font",
                                        {
                                          staticStyle: {
                                            "vertical-align": "inherit"
                                          }
                                        },
                                        [
                                          _c(
                                            "font",
                                            {
                                              staticStyle: {
                                                "vertical-align": "inherit"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.content1))]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            {
                                              staticStyle: {
                                                "vertical-align": "inherit"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.content2))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "swiper-notification",
                          attrs: {
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "top-News pt-0 pb-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "st-Grid_Inner1 st-Grid_Inner_appear p-0 pl-md-5"
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "sw-Section_Header1",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("span", { staticClass: "sw-Section_Header-en" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("PRODUCT SHOW")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sw-Section_Header-ja" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                {
                                  staticStyle: { "vertical-align": "inherit" }
                                },
                                [
                                  _c(
                                    "font",
                                    {
                                      staticStyle: {
                                        "vertical-align": "inherit"
                                      }
                                    },
                                    [_vm._v("精密部品展示")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "st-News_Slide swiper-container-news swiper-container-initialized swiper-container-horizontal appear",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "swiper-wrapper" },
                          _vm._l(_vm.newsData1, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "swiper-slide swiper-slide-news"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: item.link, target: "_blank" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "st-News_Slide-image" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "st-News_Slide-image-inner"
                                          },
                                          [
                                            _c("div", {
                                              style: {
                                                "background-image": item.imgSrc
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "sw-Eyebrow" }, [
                                      _c(
                                        "p",
                                        { staticClass: "sw-Eyebrow_Category" },
                                        [
                                          _c(
                                            "font",
                                            {
                                              staticStyle: {
                                                "vertical-align": "inherit"
                                              }
                                            },
                                            [
                                              _c("font", {
                                                staticStyle: {
                                                  "vertical-align": "inherit"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "sw-Eyebrow_Date" },
                                        [
                                          _c(
                                            "font",
                                            {
                                              staticStyle: {
                                                "vertical-align": "inherit"
                                              }
                                            },
                                            [
                                              _c(
                                                "font",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "inherit",
                                                    "background-color":
                                                      "#c7000b",
                                                    color: "white",
                                                    padding: "3px 6px"
                                                  }
                                                },
                                                [_vm._v("more......")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "st-News_Slide-title" },
                                      [
                                        _c(
                                          "font",
                                          {
                                            staticStyle: {
                                              "vertical-align": "inherit"
                                            }
                                          },
                                          [
                                            _c(
                                              "font",
                                              {
                                                staticStyle: {
                                                  "vertical-align": "inherit"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.content1))]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _vm._m(6),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "swiper-notification",
                          attrs: {
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._m(7)
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", { staticClass: "series-Nav sw-stickyTrigger-target" }, [
      _c("div", { staticClass: "series-Nav_Inner" }, [
        _c("ul", [
          _c("li", { attrs: { "data-series": "guzzilla" } }, [
            _c("a", { attrs: { href: "/product/product-0001" } }, [
              _c("p", [
                _c("img", {
                  staticStyle: { height: "50px", "object-fit": "cover" },
                  attrs: {
                    src: require("../../../../static/img/landing/main5.png"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "pl-5" }, [_vm._v("光学曲線研削加工")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "current", attrs: { "data-series": "grasper" } },
            [
              _c("a", { attrs: { href: "/product/product-0002" } }, [
                _c("p", [
                  _c("img", {
                    staticStyle: { height: "50px", "object-fit": "cover" },
                    attrs: {
                      src: require("../../../../static/img/landing/main7.png"),
                      alt: ""
                    }
                  })
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "pl-5" }, [
                  _vm._v("精密ワイヤーカット")
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("li", { attrs: { "data-series": "mag-gon" } }, [
            _c("a", { attrs: { href: "/product/product-0003" } }, [
              _c("p", [
                _c("img", {
                  staticStyle: { height: "50px", "object-fit": "cover" },
                  attrs: {
                    src: require("../../../../static/img/landing/main6.png"),
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "pl-5" }, [_vm._v("精密平面研削")])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../static/img/landing/logo_white.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("精密ワイヤーカット")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target innovation-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/landing/main7.png) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "product-Detail" }, [
      _c("div", { staticClass: "product-Detail_Inner" }, [
        _c(
          "p",
          {
            staticClass: "product-Detail_Lead appear",
            attrs: { "data-appear": "" }
          },
          [
            _vm._v("\n              精密ワイヤーカット加工"),
            _c("br"),
            _vm._v(
              "日本製西部M50B精密ワイヤーカット機及びSodick AQ360LXsワイヤーカット機、加工精度は±0.002、光沢度はRaO.31、最小径はΦ0.07mm,最小コーナン処理はR0.06,各複雑な部品加工或は異形状精密加工に満足できます。\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product-Detail_Body" }, [
          _c("div", { staticClass: "product-Detail_Column" }, [
            _c(
              "div",
              {
                staticClass: "product-Detail_Column-image",
                attrs: { "data-appear": "" }
              },
              [
                _c("picture", [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/img/landing/main7.png"),
                      alt: ""
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "product-Detail_Column-text-appear",
                attrs: { "data-appear": "" }
              },
              [
                _c(
                  "h3",
                  {
                    staticClass: "product-Detail_Column-copy",
                    staticStyle: { color: "#c7000b" }
                  },
                  [_vm._v("PRECISION WEDM Processing")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "product-Detail_Column-text" }, [
                  _vm._v(
                    "Japan Seibu High precision WEDM M50B and Sodick WEDM AQ360LXs,processingacctiracyupto ±2μm, finish up to RaO.31,min. line diameter ΦO.07 mm, the best clearance angle RO.06, It can satisfy all kinds of mould complex inlay or special cavity parts fine processing."
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product-Detail_Column" }, [
            _c(
              "div",
              {
                staticClass: "product-Detail_Column-image",
                attrs: { "data-appear": "" }
              },
              [
                _c("picture", [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/img/landing/main7.png"),
                      alt: ""
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "product-Detail_Column-text-appear",
                attrs: { "data-appear": "" }
              },
              [
                _c("p", { staticClass: "product-Detail_Column-lead" }, [
                  _vm._v("精密慢走丝加工")
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "product-Detail_Column-copy" }, [
                  _vm._v("精密慢走丝加工 ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "product-Detail_Column-text" }, [
                  _vm._v(
                    "日本西部制精密慢走丝M50B以及沙迪克制慢走丝AQ360LXsm. 加工零件最高精度可达±2μm，面精度可达RaO.31,最小线径Φ0.07mm, 最佳清角R0.06. 完全可以满足各类模具复杂镶件或异形腔零件精准加工。"
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-next" }, [
      _c("i", {
        staticClass: "icf el-icon-arrow-right",
        staticStyle: { "font-size": "25px", bottom: "15px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "swiper-button-prev swiper-button-disabled" },
      [
        _c("i", {
          staticClass: "icf el-icon-arrow-left",
          staticStyle: { "font-size": "25px", bottom: "15px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-next" }, [
      _c("i", {
        staticClass: "icf el-icon-arrow-right",
        staticStyle: { "font-size": "25px", bottom: "15px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "swiper-button-prev swiper-button-disabled" },
      [
        _c("i", {
          staticClass: "icf el-icon-arrow-left",
          staticStyle: { "font-size": "25px", bottom: "15px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-Breadcrumbs" }, [
      _c(
        "ul",
        {
          staticClass: "st-BreadcrumbsList",
          attrs: { itemscope: "itemscope", itemtype: "" }
        },
        [
          _c(
            "li",
            {
              staticClass: "st-BreadcrumbsList_Item",
              attrs: {
                itemprop: "itemListElement",
                itemscope: "itemscope",
                itemtype: ""
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "st-BreadcrumbsList_Item-link",
                  attrs: { href: "/", itemprop: "item" }
                },
                [_vm._v("ホーム")]
              ),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "position", content: "1" } })
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "st-BreadcrumbsList_Item",
              attrs: {
                itemprop: "itemListElement",
                itemscope: "itemscope",
                itemtype: ""
              }
            },
            [
              _c(
                "p",
                {
                  staticStyle: { "margin-bottom": "0rem" },
                  attrs: { itemprop: "item", "aria-current": "page" }
                },
                [
                  _c("span", { attrs: { itemprop: "name" } }, [
                    _vm._v("精密ワイヤーカット")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "position", content: "3" } })
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e05958a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e05958a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/product/product-0002.vue
// module id = null
// module chunks = 